import React, { useState, useCallback } from 'react';

let addToast = () => {};
export const toast = {
  success: (msg) => addToast({ msg, type: 'success', icon: 'fa-check-circle' }),
  error: (msg) => addToast({ msg, type: 'error', icon: 'fa-circle-xmark' }),
  info: (msg) => addToast({ msg, type: '', icon: 'fa-circle-info' }),
  warning: (msg) => addToast({ msg, type: 'warning', icon: 'fa-triangle-exclamation' }),
};

export default function ToastContainer() {
  const [toasts, setToasts] = useState([]);

  addToast = useCallback((t) => {
    const id = Date.now();
    setToasts(ts => [...ts, { id, ...t }]);
    setTimeout(() => setToasts(ts => ts.filter(x => x.id !== id)), 3000);
  }, []);

  return (
    <div className="toast-container">
      {toasts.map(t => (
        <div key={t.id} className={`toast ${t.type}`}>
          <i className={`fas ${t.icon}`}></i>
          {t.msg}
        </div>
      ))}
    </div>
  );
}
